import adminApiFetch from './apiService';

const orderPostProcessorService = {
  // 獲取列表
  getRecords: async (params = {}) => {
    const res = await adminApiFetch('order_post_processors/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取單個
  get: async (id) => {
    const res = await adminApiFetch(`order_post_processors/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 創建
  create: async (data) => {
    const res = await adminApiFetch('order_post_processors', {
      method: 'POST',
      body: { order_post_processor: data }
    });
    return res.json();
  },

  // 更新
  update: async (id, data) => {
    const res = await adminApiFetch(`order_post_processors/${id}`, {
      method: 'PUT',
      body: { order_post_processor: data }
    });
    return res.json();
  },

  // 刪除
  delete: async (id) => {
    const res = await adminApiFetch(`order_post_processors/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  }
};

export { orderPostProcessorService };
export default orderPostProcessorService;
